import { useState } from "react";
import { DotLoader } from "react-spinners";
import "../assets/styles/Loading.css";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#706EF3",
};

function Loading() {
  let [loading, setLoading] = useState(true);
  let [color, setColor] = useState("#706EF3");

  return (
    <div className="loading-overlay">
      <DotLoader
        color={color}
        loading={loading}
        cssOverride={override}
        size={70}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}

export default Loading;
